var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showPreviewImg)?_c('el-image-viewer',{attrs:{"on-close":_vm.onClose,"url-list":_vm.imgList,"initial-index":_vm.showIndex}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }